import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'checkbox-field',
    templateUrl: './checkbox-field.component.html',
    styleUrls: ['./checkbox-field.component.scss'],
    standalone: false
})
export class CheckboxFieldComponent implements OnInit {
    @Input() public value: boolean = false;
    @Input() public readonly: boolean = false;

    @Input() public title: string = '';

    @Output() public valueChange = new EventEmitter<boolean>();

    constructor() { }

    public ngOnInit(): void {

    }
}
